var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { asThemeConsumer } from "../../../../theme/Theme";
import { joinClasses } from "../../../../utils/Filters";
import { FlexColumn } from "./Column";
/**
 *
 * @param props
 */
var FlexSidebarComp = function (props) {
    var modalClass = !!props.isModal
        ? joinClasses("scl-b-app__sidebar--modal", "scl-h-animation--sidebar-modal")
        : undefined;
    var clazzName = joinClasses(props.className, "scl-b-app__sidebar", props.isCollapsed ? "scl-b-app__sidebar-collapsed" : "scl-b-app__sidebar-expanded", modalClass);
    var processed = __assign(__assign({}, props), { className: clazzName, isFixed: true, isPage: true });
    return (React.createElement(FlexColumn, __assign({}, processed)));
};
/**
 *
 */
export var FlexSidebar = asThemeConsumer(FlexSidebarComp);
